import { useLoadPageComponents, useLogger } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import HeroCarousel from '@/common/components/heroCarousel/HeroCarousel'
import { useGetHeroBannerPageProps } from '@/common/components/OmniaHeroCarousel/props'
import { PageTitle } from '@/common/components/pageTitle/PageTitle'
import { HeaderFoodDrinkIntercept } from '@/common/utils/HeaderFoodDrinkIntercept'
import { Grid } from '@/features/grid/Grid'
import { Meta } from '@/features/seo/Meta'
import { HomePageResponse } from './props'

export const HomePage: FC = () => {
    const logger = useLogger('HomePage')
    const { pageResponse, isPending } = useLoadPageComponents(new HomePageResponse())
    const { carouselConfig } = useGetHeroBannerPageProps('HeroBanner', pageResponse.heroCarousel?.length)

    logger.trace('Rendering', { pageResponse, isPending })

    if (isPending) {
        return null
    }

    return (
        <>
            <HeaderFoodDrinkIntercept />
            <Meta {...pageResponse} />
            {pageResponse.heroCarousel?.length && (
                <HeroCarousel slides={pageResponse.heroCarousel} carouselConfig={carouselConfig} />
            )}
            <PageTitle text={pageResponse.pageTitle || pageResponse.name} hide={pageResponse.hideTitle} />
            <Grid rows={pageResponse.grid} />
        </>
    )
}
